<script>
import Permission from './Permission'
export default {
  name: 'docPermission',
  extends: Permission,
  data () {
    return {
      dataType: 3,
      headers: {
        content: '这里是文档权限管理',
        title: '操作说明：'
      }
    }
  }
}
</script>
